var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedyer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "210 30 70 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ledyerGradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFDF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#DC80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6633FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 349,
    height: 93,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216,77 271,77 271,87 212,87",
    fill: "url(#ledyerGradient)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226,55 271,55 271,65 222,65",
    fill: "url(#ledyerGradient)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236,33 271,33 271,44 231,44",
    fill: "url(#ledyerGradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedyer);
export default __webpack_public_path__ + "static/media/ledyer.3ffd847d1824fab6d45deeffbb74226f.svg";
export { ForwardRef as ReactComponent };